import React from 'react';
import PropTypes from 'prop-types';

import { Tag } from 'edcom-ui';

import styles from './Standards.module.less';
import useCookie from '../../edcom-ui/hooks/useCookie';

const Standards = ({ standards, standardOptions }) => {
  const [standardCookie, setStandardCookie] = useCookie('categoryStandard');
  const [selectedStandard, setSelectedStandard] = React.useState(
    standardCookie ? standardCookie : 'CCSS'
  );

  const getSelectedAlignedStandards = selectedStandard => {
    let standardData = standardOptions
      .reduce((acc, val) => acc.concat(val.options), [])
      .find(elem => elem.internalName === selectedStandard);

    const value = standardData?.internalName ?? 'CCSS';
    if (typeof standardData === 'undefined') {
      setStandardCookie('CCSS');
    }

    return standards.filter(item => {
      if (typeof item.type !== 'undefined') {
        return item.type === selectedStandard;
      } else {
        let prefixRegExp = new RegExp('^' + value + '*', 'g');
        return item.urlName.match(prefixRegExp);
      }
    });
  };

  const clickStandard = elem => {
    setStandardCookie(elem);
    setSelectedStandard(elem);
  };

  let standardSelector = null;
  if (standardOptions) {
    const standardSelectorOptions = standardOptions.map(elem => {
      let optionGroup = elem.options.map(elem => {
        return (
          <option key={elem.internalName} value={elem.internalName}>
            {elem.name}
          </option>
        );
      });
      return (
        <optgroup key={elem.name} label={elem.name}>
          {optionGroup}
        </optgroup>
      );
    });
    standardSelector = (
      <select
        onChange={e => clickStandard(e.target.value)}
        value={selectedStandard}
        className={styles.standardSelector + ' standards-selector'}
        data-testid="standardSelector"
      >
        {standardSelectorOptions}
      </select>
    );
  }

  let shownStandards = null;
  const resourceStandards = getSelectedAlignedStandards(selectedStandard);

  if (resourceStandards.length) {
    const standardList = resourceStandards.map(elem => {
      const contents = elem.href ? (
        <a href={elem.href}>{elem.name}</a>
      ) : (
        elem.name
      );
      return (
        <Tag key={elem.urlName} className={styles.tag}>
          {contents}
        </Tag>
      );
    });
    shownStandards = (
      <div className={styles.standardListContainer}>{standardList}</div>
    );
  } else if (selectedStandard && !resourceStandards.length) {
    shownStandards = (
      <div className={styles.emptyStandards}>
        No standards associated with this content.
      </div>
    );
  }

  return (
    <>
      {standardSelector}
      {shownStandards}
    </>
  );
};

Standards.propTypes = {
  standardOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          slug: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  standards: PropTypes.arrayOf(
    PropTypes.shape({
      urlName: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Standards;
